module.exports = __webpack_public_path__ + "img/shutterstock_637780504-1-1024x512.968620c3.jpg";